import api from "@/services/api";

const { post } = api.getPrefixedMethods("efax");

export const eFaxService = {
  postSendOutgoingFax({
    text,
    templateId,
    toFaxNumbers,
    fileLinks,
    attachment,
    orderInfoKey,
    intakeOrderId,
    intakeDocumentKey,
    appeal,
    appealAttachmentLinks,
  }) {
    const data = { text, toFaxNumbers, fileLinks };
    if (templateId) {
      data.templateId = templateId;
    }
    if (attachment) {
      data.attachment = attachment;
    }
    if (orderInfoKey) {
      data.orderInfoKey = orderInfoKey;
    }
    if (intakeOrderId) {
      data.intakeOrderId = intakeOrderId;
    }
    if (intakeDocumentKey) {
      data.intakeDocumentKey = intakeDocumentKey;
    }
    if (appeal) {
      data.appeal = true;
    }
    if (appealAttachmentLinks?.length) {
      data.appealAttachmentLinks = appealAttachmentLinks;
    }
    return post(`send-outgoing-fax/`, data);
  },
};
